
class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    this._fill     = this.querySelector('.hdt-fcs__progress-fill');
    this._observer = null;

    requestAnimationFrame(() => this._tryInitDots());

    const slider = this.querySelector('hdt-slider');
    if (slider) {
      slider.addEventListener(
        'scroll',
        (e) => this._onScrollFallback(e),
        { passive: true, capture: true }
      );
    }
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  _tryInitDots(n = 0) {
    const dots = this.querySelector('[hdt-slider-dots]') ||
                 this.querySelector('.hdt-slider__dots');

    if (!dots) {
      if (n < 25) setTimeout(() => this._tryInitDots(n + 1), 100);
      return;
    }

    this._observer = new MutationObserver(() => this._syncByDots(dots));
    this._observer.observe(dots, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-selected'],
    });

    if (dots.children.length) this._syncByDots(dots);
  }

  _syncByDots(dotsEl) {
    if (!this._fill) return;
    const items = dotsEl.querySelectorAll('button, [role="tab"], .hdt-slider__dot');
    const total = items.length;
    if (!total) return;

    const idx = Array.from(items).findIndex(
      (d) =>
        d.classList.contains('hdt-slider__dot--selected') ||
        d.classList.contains('is-active') ||
        d.getAttribute('aria-selected') === 'true'
    );
    const current = idx >= 0 ? idx : 0;
    this._fill.style.width = `${((current + 1) / total) * 100}%`;
  }

  _onScrollFallback(e) {
    const el = e.target;
    if (
      !el.classList.contains('hdt-slider__container') &&
      !el.classList.contains('hdt-slider__viewport')
    ) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;
    const max = scrollWidth - clientWidth;
    if (max <= 0) {
      this._fill && (this._fill.style.width = '100%');
      return;
    }
    const pct = Math.min(100, Math.round((scrollLeft / max) * 100));
    if (this._fill) this._fill.style.width = `${pct}%`;
  }
}

if (!customElements.get('featured-collection')) {
  customElements.define('featured-collection', FeaturedCollection);
}
